import { render, staticRenderFns } from "./FooterNavList.vue?vue&type=template&id=173f85b7&scoped=true&"
import script from "./FooterNavList.vue?vue&type=script&lang=ts&"
export * from "./FooterNavList.vue?vue&type=script&lang=ts&"
import style0 from "./FooterNavList.vue?vue&type=style&index=0&id=173f85b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f85b7",
  null
  
)

export default component.exports